import MicroForm from './MicroForm';

export default MicroForm;
